// extracted by mini-css-extract-plugin
module.exports = {"largeImage":"MeridionalSection-module--largeImage--3RR3S","smallImage":"MeridionalSection-module--smallImage--1QkN_"};